import React from 'react'
import PropTypes from 'prop-types'

// Components
import AnimateSlideText from '../animation/AnimateSlideText'

// SVGs
import Arrow from '../svgs/Arrow'

// Styles
import { CarouselNavMain, CarouselNavButton } from './index.style'

const CarouselNav = ({
  id,
  align,
  color,
  prevEvent,
  nextEvent,
  nextSlideLabel,
  prevSlideLabel,
}) => {
  return (
    <CarouselNavMain align={align}>
      <AnimateSlideText id={`${id}-prev`}>
        {prevEvent && (
          <CarouselNavButton
            onClick={prevEvent}
            aria-label={prevSlideLabel ? prevSlideLabel : 'Previous Slide'}
            flip={true}
            color={color}
          >
            <Arrow stroke={color} />
            <Arrow stroke={color} />
          </CarouselNavButton>
        )}
      </AnimateSlideText>
      <AnimateSlideText id={`${id}-next`}>
        {nextEvent && (
          <CarouselNavButton
            onClick={nextEvent}
            aria-label={nextSlideLabel ? nextSlideLabel : 'Next Slide'}
            color={color}
          >
            <Arrow stroke={color} />
            <Arrow stroke={color} />
          </CarouselNavButton>
        )}
      </AnimateSlideText>
    </CarouselNavMain>
  )
}

CarouselNav.propTypes = {
  id: PropTypes.string.isRequired,
  align: PropTypes.string,
  color: PropTypes.string,
  prevEvent: PropTypes.func,
  nextEvent: PropTypes.func,
}

export default CarouselNav
